import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-white text-xl">
                <i className="ri-book-open-line"></i>
              </span>
              <span className="font-heading font-bold text-lg text-white">
                韩漫大全无删减免费阅读下拉
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-md">
              专注韩漫在线阅读，资源丰富、题材多样，主打无删减内容与便捷的下拉式连续阅读体验，陪伴每一位漫画爱好者追漫到底。
            </p>
            <p className="mt-4 text-xs text-primary-300 max-w-md leading-relaxed">
              温馨提示：本站为前端演示站点，所有漫画数据、搜索与分页均为模拟内容，仅用于展示阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-base">
              热门题材
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category?cat=${cat.id}`}
                    className="text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-base">
              快捷导航
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-accent-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-background-300 hover:text-accent-400 transition-colors">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-300 hover:text-accent-400 transition-colors">
                  搜索漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 韩漫大全无删减免费阅读下拉 · 本站内容仅供演示学习使用</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            尊重版权，请支持正版漫画
          </p>
        </div>
      </div>
    </footer>
  );
}